import {userInfoLoader} from "@/utils/storage/extra/loaders/user/userInfoLoader";
import {UserInfo} from "@/types/User/UserInfo.interface";
import {useEffect, useState} from "react";
import {RootState, useAppDispatch, useAppSelector} from "@/utils/storage/stores/store";
import {cartOfferLoader} from "@/utils/storage/extra/loaders/cart/cartOfferLoader";
import {InitSitePreloader} from "@/ui/Loader/InitSitePreloader/InitSitePreloader.tsx";

/** Загрузка приложения */
export const AppLoad = ({children}: { children: React.ReactNode }) => {
    const dispatch = useAppDispatch();
    const userInfo: UserInfo | null = useAppSelector((state: RootState) => state.user.userInfo);
    const isUserInfoLoading = useAppSelector((state: RootState) => state.user.loading.userInfo);
    const userInfoError = useAppSelector((state: RootState) => state.user.error.userInfo);
    const isMiniCartLoading = useAppSelector((state: RootState) => state.cart.loading.miniCart);
    const miniCartError = useAppSelector((state: RootState) => state.cart.error.miniCart);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(true);

    /** Загрузка информации о пользователе */
    useEffect(() => {
        dispatch(userInfoLoader());
        setIsInitialLoading(false);
    }, []);

    /** Загрузка корзины */
    useEffect(() => {
        if (userInfo?.cartId && !isInitialLoading) {
            dispatch(cartOfferLoader({cartId: userInfo.cartId, isMini: true}));
        }
    }, [userInfo]);

    /** Отключение прелоадера */
    useEffect(() => {
        let timer: NodeJS.Timeout | number | undefined;

        if (!isUserInfoLoading && !isMiniCartLoading) {
            timer = setTimeout(() => setIsLoading(false), 300);
        }

        return () => {
            clearTimeout(timer);
        }
    }, [isUserInfoLoading, isMiniCartLoading]);

    if (userInfoError || miniCartError) {
        const errorMessage = userInfoError?.message || miniCartError?.message;
        console.error(errorMessage);
        return <div>{errorMessage}</div>;
        //TODO: Добавить механизм повторной отправки запроса
    }

    return (
        <>
            <InitSitePreloader isLoading={isLoading}/>
            {children}
        </>
    );
};
